import { Loader2 } from 'lucide-react';

export function LoadingFallback() {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Carregando página"
      className="min-h-[50vh] flex items-center justify-center"
    >
      <Loader2
        size={32}
        className="animate-spin"
        style={{ color: 'var(--cyan)' }}
        aria-hidden="true"
      />
      <span className="sr-only">Carregando...</span>
    </div>
  );
}
